const ON_CHANGE_DEBOUNCE_TIMER=300,PUB_SUB_EVENTS={cartUpdate:"cart-update",quantityUpdate:"quantity-update",variantChange:"variant-change"};
//# sourceMappingURL=/s/files/1/0729/0742/4056/t/6/assets/constants.js.map?v=1701539384
